import { Form } from 'react-bootstrap';
import { WebhookEventHelpTip } from './WebhookEventHelpTip';

export function ScheduleWebhookEventsForm({
  title,
  catalog,
  events,
  onChange,
}: {
  title: string;
  catalog: readonly { id: string; label: string; description?: string }[];
  events: string[];
  onChange: (events: string[]) => void;
}) {
  function toggle(eventId: string) {
    onChange(
      events.includes(eventId)
        ? events.filter((id) => id !== eventId)
        : [...events, eventId],
    );
  }

  return (
    <div className="mb-3">
      <Form.Label className="mb-2">{title}</Form.Label>
      <div className="d-grid gap-2">
        {catalog.map((item) => (
          <Form.Check
            key={item.id}
            type="checkbox"
            id={`schedule-webhook-${item.id}`}
            label={
              <>
                <span>{item.label}</span>
                {item.description && (
                  <WebhookEventHelpTip
                    title={item.label}
                    paragraphs={[item.description]}
                  />
                )}
              </>
            }
            checked={events.includes(item.id)}
            onChange={() => toggle(item.id)}
          />
        ))}
      </div>
    </div>
  );
}
